export const JOURNEY_TRANSLATIONS = {
  fr: {
    "journey.nav": "Mon Parcours",
    "journey.title": "Parcours guidé par LIA",
    "journey.eyebrow": "MON PARCOURS",
    "journey.subtitle": "Un parcours généré à partir de vos réponses, sans appel à une intelligence artificielle.",
    "journey.free": "Inclus dans Eternua Essentiel",
    "journey.private": "Privé par défaut",
    "journey.empty.title": "Quel est votre objectif aujourd’hui ?",
    "journey.empty.text": "Choisissez un parcours et avancez étape par étape avec LIA.",
    "journey.create": "Créer un nouveau parcours",
    "journey.continue": "Continuer mon parcours",
    "journey.history": "Voir l’historique",
    "journey.back.home": "Retour à Mon Parcours",
    "journey.loading": "Chargement de votre parcours privé…",
    "journey.error.title": "Votre parcours est momentanément indisponible",
    "journey.error.text": "Vos données restent enregistrées. Réessayez dans un instant.",
    "journey.offline.title": "Vous êtes hors ligne",
    "journey.offline.text": "Reconnectez-vous pour retrouver votre parcours enregistré.",
    "journey.retry": "Réessayer",
    "journey.progress": "Progression réelle",
    "journey.next": "Prochaine étape",
    "journey.deadline": "Prochaine échéance",
    "journey.recent": "Étapes récemment terminées",
    "journey.none.recent": "Aucune étape terminée pour le moment.",
    "journey.deadlines.near": "Échéances proches",
    "journey.deadlines.none": "Aucune échéance proche.",
    "journey.active.count": "parcours actifs",
    "journey.available.count": "7 objectifs disponibles · Aucun crédit consommé",
    "journey.steps.done": "étapes terminées",
    "journey.advice.label": "Conseil préparé par Eternua",
    "journey.advice.ready": "Votre parcours est prêt. Commençons par une première étape simple.",
    "journey.advice.next": "Une étape terminée, bravo. Voici la prochaine action prévue.",
    "journey.advice.deadline": "Votre échéance approche. Vous pouvez la conserver ou la reporter.",
    "journey.advice.half": "Vous avez terminé la moitié du parcours.",
    "journey.advice.completed": "Votre parcours est terminé. Votre historique reste enregistré.",
    "journey.wizard.title": "Créer un parcours",
    "journey.wizard.goal": "Quel est votre objectif principal ?",
    "journey.wizard.common": "Quelques repères pour organiser votre parcours",
    "journey.wizard.specific": "Une dernière question adaptée à votre objectif",
    "journey.wizard.summary": "Résumé de vos réponses",
    "journey.wizard.preview": "Aperçu des étapes",
    "journey.wizard.help": "Vos réponses servent uniquement à sélectionner et ordonner des étapes prédéfinies.",
    "journey.wizard.previous": "Précédent",
    "journey.wizard.next": "Continuer",
    "journey.wizard.preview.action": "Préparer l’aperçu",
    "journey.wizard.validate": "Valider et créer mon parcours",
    "journey.wizard.creating": "Enregistrement du parcours…",
    "journey.wizard.select": "Choisir une réponse",
    "journey.wizard.optional": "Facultatif",
    "journey.wizard.change": "Modifier mes réponses",
    "journey.wizard.step.goal": "Objectif",
    "journey.wizard.step.common": "Repères",
    "journey.wizard.step.specific": "Question adaptée",
    "journey.wizard.step.summary": "Résumé",
    "journey.wizard.step.preview": "Aperçu",
    "journey.wizard.steps.label": "Étapes de création",
    "journey.wizard.preparing": "Préparation…",
    "journey.wizard.preview.text": "Ces étapes seront enregistrées une seule fois. Vous pourrez ensuite les suivre, les reporter ou les ignorer.",
    "journey.wizard.due.proposed": "Échéance proposée",
    "journey.wizard.verification": "VÉRIFICATION",
    "journey.wizard.validation": "VALIDATION",
    "journey.detail.timeline": "Étapes du parcours",
    "journey.detail.history": "Activité récente",
    "journey.detail.checklist": "CHECKLIST PRIVÉE",
    "journey.detail.due": "Échéance",
    "journey.detail.version": "MODÈLE",
    "journey.detail.privacy": "Ce parcours n’apparaît jamais sur votre profil public.",
    "journey.step.start": "Commencer",
    "journey.step.complete": "Marquer comme terminée",
    "journey.step.undo": "Annuler la validation",
    "journey.step.skip": "Ignorer cette étape",
    "journey.step.restore": "Restaurer l’étape",
    "journey.step.postpone": "Reporter de 7 jours",
    "journey.step.agenda": "Ajouter à l’agenda",
    "journey.step.agenda.done": "Ajoutée à l’agenda",
    "journey.step.open": "Ouvrir la rubrique Eternua",
    "journey.status.todo": "À faire",
    "journey.status.in_progress": "En cours",
    "journey.status.completed": "Terminée",
    "journey.status.skipped": "Ignorée",
    "journey.archive": "Archiver le parcours",
    "journey.archive.confirm": "Archiver ce parcours ? Ses étapes et sa progression seront conservées.",
    "journey.complete": "Marquer le parcours comme terminé",
    "journey.complete.help": "Toutes les étapes doivent être terminées ou ignorées.",
    "journey.history.title": "Historique des parcours",
    "journey.history.eyebrow": "ARCHIVES PRIVÉES",
    "journey.history.active": "Actifs",
    "journey.history.completed": "Terminés",
    "journey.history.archived": "Archivés",
    "journey.history.empty": "Aucun parcours dans cette catégorie.",
    "journey.restore": "Restaurer le parcours",
    "journey.open": "Ouvrir le parcours",
    "journey.activity.journey_created": "Parcours créé",
    "journey.activity.step_start": "Étape commencée",
    "journey.activity.step_complete": "Étape terminée",
    "journey.activity.step_undo": "Validation annulée",
    "journey.activity.step_skip": "Étape ignorée",
    "journey.activity.step_restore": "Étape restaurée",
    "journey.activity.step_postpone": "Échéance reportée",
    "journey.activity.agenda_added": "Échéance ajoutée à l’agenda",
    "journey.activity.agenda_updated": "Échéance d’agenda mise à jour",
    "journey.activity.journey_archived": "Parcours archivé",
    "journey.activity.journey_restored": "Parcours restauré",
    "journey.activity.journey_completed": "Parcours terminé",
  },
  en: {
    "journey.nav": "My Journey",
    "journey.title": "Journey guided by LIA",
    "journey.subtitle": "A journey created from your answers, without any AI service call.",
    "journey.free": "Included in Eternua Essential",
    "journey.private": "Private by default",
    "journey.create": "Create a new journey",
    "journey.continue": "Continue my journey",
    "journey.history": "View history",
    "journey.loading": "Loading your private journey…",
    "journey.retry": "Try again",
    "journey.progress": "Actual progress",
    "journey.next": "Next step",
    "journey.advice.label": "Advice prepared by Eternua",
    "journey.advice.ready": "Your journey is ready. Let’s begin with a simple first step.",
    "journey.advice.next": "One step complete. Here is your next planned action.",
    "journey.advice.deadline": "Your deadline is approaching. You can keep it or postpone it.",
    "journey.advice.half": "You have completed half of the journey.",
    "journey.advice.completed": "Your journey is complete. Its history remains saved.",
  },
};
